import { render, staticRenderFns } from "./Role.vue?vue&type=template&id=d8d38dae&scoped=true"
import script from "./Role.vue?vue&type=script&lang=js"
export * from "./Role.vue?vue&type=script&lang=js"
import style0 from "./Role.vue?vue&type=style&index=0&id=d8d38dae&prod&scoped=true&lang=css"
import style1 from "./Role.vue?vue&type=style&index=1&id=d8d38dae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d38dae",
  null
  
)

export default component.exports